<template>
  <Question
    :alternate-title="$t('Next step')"
    :title="$t('kyc.titles.financial', { year: 2018 })"
    :progress-ratio="1/4"
    back-route="/kyc/ppe"
    next-button-theme="primary"
    @next="next"
  >
    <FinancialContent />
  </Question>
</template>

<script>
import kyc from '../../mixins/kyc';
import Question from './Question.vue';
import BaseSection from '../../components/BaseSection.vue';
import BaseTitleGroup from '../../components/BaseTitleGroup.vue';
import BaseParagraph from '../../components/BaseParagraph.vue';
import FinancialContent from './FinancialContent.vue';

export default {
  name: 'Financial',
  components: {
    Question,
    BaseSection,
    BaseTitleGroup,
    BaseParagraph,
    FinancialContent,
  },
  mixins: [kyc],
  methods: {
    next() {
      this.$router.push('/kyc/property');
    },
  },
};
</script>
